import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ADMIN_API_ENDPOINTS } from "service/apiUrl";
import { API } from "service/Interceptor";

const initialState = {
  posts: [],
  filters: {
    fromDate: "",
    toDate: "",
    status: "",
    flaggedStatus: "",
    userType: "",
  },
  totalCount: null,
  isPostsLoading: false,
  hasError: false,
  isExporting: false,
};

export const getAllPosts = createAsyncThunk(
  "get-all-posts",
  async ({ pageSelected, search, filters }) => {
    try {
      const { fromDate, toDate, userType, status, flaggedStatus } = filters || {};

      const queryParams = new URLSearchParams({
        search: search || "",
        export: "false",
        pageNo: pageSelected,
        perPage: 10,
      });

      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);
      if (userType) queryParams.append("userType", userType);
      if (status) queryParams.append("isActive", status);
      if (flaggedStatus) queryParams.append("flaggedStatus", flaggedStatus);

      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.POSTS}?${queryParams.toString()}`
      );

      return {
        data: res?.data?.data?.results,
        totalRecord: res?.data?.data?.totalRecord,
      };
    } catch (error) {
      console.log("error", error);
    }
  }
);

export const handlePostStatus = createAsyncThunk(
  "update-post-status",
  async (payload) => {
    try {
      await API.post(ADMIN_API_ENDPOINTS.POST_STATUS, {
        status: payload?.isActive,
        postId: payload?.postId,
        message: payload?.message,
      });

      return {
        postId: payload?.postId,
        reportMessage: payload.message,
      };
    } catch (error) {
      console.log(error);
    }
  }
);

export const handlePostFlaggedStatus = createAsyncThunk(
  "update-post-flagged-status",
  async (payload) => {
    try {
      await API.put(ADMIN_API_ENDPOINTS.POST_FLAG_STATUS, payload);
      return payload;
    } catch (error) {
      console.log(error);
    }
  }
);

export const exportPosts = createAsyncThunk("export-posts", async (payload) => {
  try {
    const res = await API.get(`${ADMIN_API_ENDPOINTS.POSTS}?export=true`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    console.log("error", error);
  }
});

export const postMonitoringSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------------GET ALL POSTS----------------------
      .addCase(getAllPosts.pending, (state, action) => {
        state.isPostsLoading = true;
        state.hasError = false;
      })
      .addCase(getAllPosts.fulfilled, (state, action) => {
        state.posts = action.payload?.data;
        state.totalCount = action.payload?.totalRecord;
        state.isPostsLoading = false;
        state.hasError = false;
      })
      .addCase(getAllPosts.rejected, (state, action) => {
        state.isPostsLoading = false;
        state.hasError = true;
      })
      // --------------------Toggle Status------------------
      .addCase(handlePostStatus.fulfilled, (state, action) => {
        const index = state.posts.findIndex(
          (row) => row.postId === action.payload?.postId
        );
        state.posts[index].isActive = !state.posts[index].isActive;
        state.posts[index].flaggedReason = action.payload.reportMessage;
      })
      // --------------------Toggle Flag Status------------------
      .addCase(handlePostFlaggedStatus.fulfilled, (state, action) => {
        const index = state.posts.findIndex(
          (row) => row.postId === action.payload?.postId
        );
        state.posts[index].isReported = !state.posts[index].isReported;
        state.posts[index].flaggedStatus = action.payload?.flaggedStatus;
      })
      // --------------------Exporting Posts------------------
      .addCase(exportPosts.pending, (state, action) => {
        state.isExporting = true;
      })
      .addCase(exportPosts.fulfilled, (state, action) => {
        state.isExporting = false;
      })
      .addCase(exportPosts.rejected, (state, action) => {
        state.isExporting = false;
      });
  },
});

export const { setFilters } = postMonitoringSlice.actions;
export default postMonitoringSlice.reducer;
